(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3619,9534,5622,794],{

/***/ 39434:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external-page",
      function () {
        return __webpack_require__(82384);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bloomreachAddToCartEvent": function() { return /* binding */ bloomreachAddToCartEvent; },
/* harmony export */   "bloomreachCategoryPagePixel": function() { return /* binding */ bloomreachCategoryPagePixel; },
/* harmony export */   "bloomreachContentPageViewPixel": function() { return /* binding */ bloomreachContentPageViewPixel; },
/* harmony export */   "bloomreachConversionEvent": function() { return /* binding */ bloomreachConversionEvent; },
/* harmony export */   "bloomreachHomePagePixel": function() { return /* binding */ bloomreachHomePagePixel; },
/* harmony export */   "bloomreachOtherPagePixel": function() { return /* binding */ bloomreachOtherPagePixel; },
/* harmony export */   "bloomreachPageViewPixel": function() { return /* binding */ bloomreachPageViewPixel; },
/* harmony export */   "bloomreachSearchEvent": function() { return /* binding */ bloomreachSearchEvent; },
/* harmony export */   "bloomreachSearchPagePixel": function() { return /* binding */ bloomreachSearchPagePixel; },
/* harmony export */   "bloomreachSuggestEventPixel": function() { return /* binding */ bloomreachSuggestEventPixel; },
/* harmony export */   "sendDataToBloomreach": function() { return /* binding */ sendDataToBloomreach; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48080);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_isShippingProtection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10304);
/* harmony import */ var _helpers_getQueryWithValidCharacters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55622);









var generateBloomreachBaseScript = function(customScript) {
    var baseScript = "\n    var brtrk = document.createElement('script');\n    brtrk.type = 'text/javascript';\n    brtrk.async = true;\n    brtrk.src = \"//cdn.brcdn.com/v1/br-trk-".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__.BLOOMREACH_ACCOUNT_ID, ".js\";\n    var s = document.getElementsByTagName('script')[0];\n    s.parentNode.insertBefore(brtrk, s);\n    var br_data = br_data || {};\n    br_data.acct_id = ").concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__.BLOOMREACH_ACCOUNT_ID, ";\n    br_data.test_data = '").concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__.IS_BLOOMREACH_TEST_ENV, "';\n  ");
    return customScript ? "".concat(baseScript, " ").concat(customScript) : baseScript;
};
var bloomreachConversionEvent = function(customerId, orderId, orderTotal, lineItems) {
    var updatedLineItems = lineItems.filter(_helpers_isShippingProtection__WEBPACK_IMPORTED_MODULE_4__/* .isNotShippingProtection */ .Y).map(function(_param) {
        var prod_id = _param.sku, sku = _param.sku, price = _param.subtotalPrice, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
            "sku",
            "sku",
            "subtotalPrice"
        ]);
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            prod_id: prod_id,
            sku: sku,
            price: price
        }, rest);
    });
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    var scriptContent = "\n      ".concat(generateBloomreachBaseScript(), "\n      br_data.ptype = 'conversion';\n  ");
    if (customerId !== undefined && customerId !== 0) {
        scriptContent += "br_data.user_id = ".concat(customerId, ";");
    }
    scriptContent += "\n      br_data.is_conversion = ".concat(1, ";\n      br_data.basket_value = ").concat(orderTotal, ";\n      br_data.order_id = ").concat(orderId, ";\n      br_data.basket = {\n          'items': ").concat(JSON.stringify(updatedLineItems), ",\n      };\n  ");
    bloomreachScript.textContent = scriptContent;
    document.body.appendChild(bloomreachScript);
};
var bloomreachSearchPagePixel = function(title, userId) {
    var ref;
    var escapedTitle = (0,_helpers_getQueryWithValidCharacters__WEBPACK_IMPORTED_MODULE_3__.escapeQuotes)(title);
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.setAttribute("id", "SearchPageViewPixel");
    bloomreachScript === null || bloomreachScript === void 0 ? void 0 : (ref = bloomreachScript.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(bloomreachScript);
    bloomreachScript.textContent = "\n        ".concat(generateBloomreachBaseScript(), '\n        br_data.ptype = "search";\n        ').concat(userId !== undefined && userId !== 0 ? "br_data.user_id = '".concat(String(userId), "';") : "", '\n        br_data.search_term = "').concat(escapedTitle, '"; \n      ');
    document.body.appendChild(bloomreachScript);
};
var bloomreachSearchEvent = function(searchString, userId) {
    if (window.BrTrk) {
        var ref, ref1;
        var searchData = {
            q: "",
            catalogs: [],
            user_id: 0
        };
        searchData.q = searchString;
        if (userId !== undefined && userId !== 0) {
            searchData.user_id = userId;
        }
        searchData.catalogs = [
            {
                "name": "onekingslane"
            }
        ];
        (ref = window.BrTrk) === null || ref === void 0 ? void 0 : (ref1 = ref.getTracker) === null || ref1 === void 0 ? void 0 : ref1.call(ref).logEvent("suggest", "submit", searchData, {}, true);
    }
};
var bloomreachAddToCartEvent = function(sku, productId) {
    if (window.BrTrk) {
        var ref, ref1;
        (ref = window.BrTrk) === null || ref === void 0 ? void 0 : (ref1 = ref.getTracker) === null || ref1 === void 0 ? void 0 : ref1.call(ref).logEvent("cart", "click-add", {
            "prod_id": productId,
            "sku": sku
        });
    }
};
var bloomreachPageViewPixel = function(product, customerId, sku) {
    if (!product) {
        return;
    }
    var prodId = product.sku.slice(1);
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("id", "PDPPixelScript");
    bloomreachScript.textContent = "\n      if (document.referrer !== document.location.href) {\n        ".concat(generateBloomreachBaseScript(), '\n          br_data.ptype = "product";\n          br_data.prod_name = \'').concat(product === null || product === void 0 ? void 0 : product.name.replace(/'/g, "\\'"), "';\n          br_data.prod_id = '").concat(prodId, "';\n          br_data.sku = '").concat(String(sku), "';\n  ");
    if (customerId !== undefined && customerId !== 0) {
        bloomreachScript.textContent += "br_data.user_id = '".concat(customerId, "';");
    }
    bloomreachScript.textContent += "\n  }\n  ";
    var script = document.getElementById("PDPPixelScript");
    if (script === null) {
        document.body.appendChild(bloomreachScript);
    }
};
var bloomreachContentPageViewPixel = function(pageTitle) {
    var bloomreachScript = document.createElement("script");
    bloomreachScript.textContent = "\n          ".concat(generateBloomreachBaseScript(), "\n          br_data.catalogs = [ { name : 'onekingslane_discovery' } ];\n          br_data.item_name = '").concat(String(pageTitle), '\';\n          br_data.ptype = "content";\n        ');
    document.body.appendChild(bloomreachScript);
};
var bloomreachSuggestEventPixel = function(searchString, searchSuggestion, userId) {
    var searchData = {
        q: "",
        aq: "",
        catalogs: []
    };
    searchData.q = searchSuggestion;
    searchData.aq = searchString;
    searchData.catalogs = [
        {
            "name": "onekingslane"
        }
    ];
    if (userId !== undefined && userId !== 0) {
        searchData.user_id = userId;
    }
    if (window.BrTrk) {
        var ref, ref1;
        (ref = window.BrTrk) === null || ref === void 0 ? void 0 : (ref1 = ref.getTracker) === null || ref1 === void 0 ? void 0 : ref1.call(ref).logEvent("suggest", "click", searchData, {}, true);
    }
};
var bloomreachCategoryPagePixel = function(breadcrumbs) {
    if (!breadcrumbs || (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) === 0) {
        return;
    }
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.textContent = "\n  if (document.referrer !== document.location.href){\n        ".concat(generateBloomreachBaseScript(), '\n          br_data.ptype = "category";\n          br_data.cat_id = ').concat(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.slice(-1)[0].id, ";\n          br_data.cat = '").concat(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function(obj) {
        return (0,_helpers_getQueryWithValidCharacters__WEBPACK_IMPORTED_MODULE_3__.escapeQuotes)(obj.name);
    }).join("|"), "';\n  }");
    document.body.appendChild(bloomreachScript);
};
var bloomreachHomePagePixel = function() {
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.textContent = "\n  if (document.referrer !== document.location.href){\n        ".concat(generateBloomreachBaseScript(), '\n          br_data.ptype = "homepage";  }');
    document.body.appendChild(bloomreachScript);
};
var bloomreachOtherPagePixel = function() {
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.textContent = "\n        ".concat(generateBloomreachBaseScript(), '\n        br_data.ptype = "other";\n        ');
    document.body.appendChild(bloomreachScript);
};
var sendDataToBloomreach = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(eventType, query, name) {
        var ref, getCustomer, customer;
        return _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 7941).then(__webpack_require__.bind(__webpack_require__, 57941)), 
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    getCustomer = ref[0].getCustomer;
                    _ctx.next = 8;
                    return getCustomer();
                case 8:
                    customer = _ctx.sent.customer;
                    if (eventType === "SearchPage") {
                        bloomreachSearchPagePixel(query, customer === null || customer === void 0 ? void 0 : customer.entityId);
                    } else if (eventType === "SuggestEvent") {
                        bloomreachSuggestEventPixel(query, name, customer === null || customer === void 0 ? void 0 : customer.entityId);
                    } else {
                        bloomreachSearchEvent(query, customer === null || customer === void 0 ? void 0 : customer.entityId);
                    }
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendDataToBloomreach(eventType, query, name) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 49125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SHIPPED_SHIELD_SKU; }
/* harmony export */ });
var SHIPPED_SHIELD_SKU = "WORRY_FREE_DELIVERY";


/***/ }),

/***/ 68533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ WORRY_FREE_DELIVERY_SKU; }
/* harmony export */ });
var WORRY_FREE_DELIVERY_SKU = "WORRY_FREE_DELIVERY";


/***/ }),

/***/ 55622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "escapeQuotes": function() { return /* binding */ escapeQuotes; },
/* harmony export */   "getQueryWithValidCharacters": function() { return /* binding */ getQueryWithValidCharacters; },
/* harmony export */   "getQueryXssEscaped": function() { return /* binding */ getQueryXssEscaped; },
/* harmony export */   "removeIllegalCharacters": function() { return /* binding */ removeIllegalCharacters; },
/* harmony export */   "xssEscape": function() { return /* binding */ xssEscape; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68924);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(xss__WEBPACK_IMPORTED_MODULE_0__);



var LEGAL_FILTER_CHARACTER_SET = /^[\w \-+,$'"&%’”./`]+$/;
var removeIllegalCharacters = function(s) {
    return s.replace(new RegExp("[^".concat(LEGAL_FILTER_CHARACTER_SET.source, "]"), "g"), "");
};
var getQueryWithValidCharacters = function(queryWithoutSlug) {
    var copied = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, queryWithoutSlug);
    var hasIllegalChar = function(str) {
        return !LEGAL_FILTER_CHARACTER_SET.test(str);
    };
    var deleteKey = function(key) {
        return delete copied[key];
    };
    Object.keys(copied).forEach(function(key) {
        var value = copied[key];
        if (!value) {
            deleteKey(key);
        } else if (Array.isArray(value)) {
            deleteKey(key);
        } else if (hasIllegalChar(value)) {
            deleteKey(key);
        }
    });
    return copied;
};
var xssEscape = function(s) {
    return xss__WEBPACK_IMPORTED_MODULE_0___default()(s);
};
var getQueryXssEscaped = function(query) {
    var escaped = Object.entries(query).reduce(function(hash, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], val = _param[1];
        if (val && !Array.isArray(val)) {
            // eslint-disable-next-line no-param-reassign
            hash[key] = xssEscape(val);
        }
        return hash;
    }, {});
    return escaped;
};
var escapeQuotes = function(s) {
    return s.replace('"', '\\"').replace("'", "\\'").replace("`", "\\`");
};
/* harmony default export */ __webpack_exports__["default"] = (getQueryWithValidCharacters);


/***/ }),

/***/ 10304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ isShippingProtection; },
/* harmony export */   "Y": function() { return /* binding */ isNotShippingProtection; }
/* harmony export */ });
/* harmony import */ var _data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49125);
/* harmony import */ var _data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68533);


var isShippingProtection = function(item) {
    return item.sku.includes(_data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_SHIELD_SKU */ .E) || item.sku.includes(_data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__/* .WORRY_FREE_DELIVERY_SKU */ .f);
};
var isNotShippingProtection = function(item) {
    return !isShippingProtection(item);
};


/***/ }),

/***/ 3876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ usePageView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48080);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);






var sendPageView = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var url, context, ref, sendDMPAnalyticsEvent;
        return _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    url = param.url, context = param.context;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("sendPageView: Sending page view for ".concat(url));
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 5;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.all(/* import() */[__webpack_require__.e(8764), __webpack_require__.e(5909)]).then(__webpack_require__.bind(__webpack_require__, 15909)), 
                        ];
                    });
                case 5:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    sendDMPAnalyticsEvent = ref[0].sendDMPAnalyticsEvent;
                    sendDMPAnalyticsEvent({
                        eventType: "pageview",
                        url: url,
                        items: [],
                        context: context
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendPageView(_) {
        return _ref.apply(this, arguments);
    };
}();
var usePageView = function(param) {
    var context = param.context, _shouldTrack = param.shouldTrack, shouldTrack = _shouldTrack === void 0 ? true : _shouldTrack;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), sent = ref[0], setSent = ref[1];
    var stringifiedContext = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return JSON.stringify(context);
    }, [
        context
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (shouldTrack && sent !== stringifiedContext) {
            setSent(stringifiedContext);
            sendPageView({
                url: window.location.href,
                context: context
            }).catch(function(e) {
                return (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("sendPageView: Error sending page view: ".concat(String(e)));
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sent,
        stringifiedContext,
        shouldTrack
    ]);
};


/***/ }),

/***/ 82384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getInitialProps": function() { return /* binding */ getInitialProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_getSiteWideInitialProps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57927);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27429);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48080);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_ScriptIntegrations_BloomreachEvents__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70794);
/* harmony import */ var _helpers_timePromiseAndLog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60599);
/* harmony import */ var _services_cscLog__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29741);
/* harmony import */ var _hooks_DmpAnalytics_usePageView__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3876);
/* eslint-disable */ 















var Default = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(__webpack_require__.e(/* import() */ 5589).then(__webpack_require__.bind(__webpack_require__, 16872)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16872)
            ];
        }
    }
});
var DESKTOP_BREAKPOINT = 768;
var registered = [];
var register = function(functor) {
    return registered.push(functor);
};
var deregister = function(functor) {
    return function() {
        registered.splice(registered.indexOf(functor), 1);
    };
};
var bound = false;
var listener = function() {
    var desktop = window.innerWidth >= DESKTOP_BREAKPOINT;
    registered.forEach(function(setter) {
        return setter(desktop);
    });
    return desktop;
};
var bind = function(setDesktop) {
    if (!bound && "object" !== "undefined" && typeof window.addEventListener === "function") {
        setDesktop(listener());
        window.addEventListener("resize", listener);
    }
};
// eslint-disable-next-line react/jsx-props-no-spreading
var PageContentDiv = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props));
};
var ExternalPage = function(param) {
    var _pageHtml = param.pageHtml, pageHtml = _pageHtml === void 0 ? "" : _pageHtml, _pageTitle = param.pageTitle, pageTitle = _pageTitle === void 0 ? "" : _pageTitle, _pageDescription = param.pageDescription, pageDescription = _pageDescription === void 0 ? "" : _pageDescription, sitewideBanner = param.sitewideBanner, megaNav = param.megaNav, isHomePage = param.isHomePage, eventBanner = param.eventBanner, footer = param.footer;
    (0,_hooks_DmpAnalytics_usePageView__WEBPACK_IMPORTED_MODULE_11__/* .usePageView */ .a)({
        context: [
            {
                key: "pageTitle",
                value: {
                    stringValue: pageTitle,
                    numberValue: null,
                    booleanValue: null
                }
            },
            {
                key: "pageDescription",
                value: {
                    stringValue: pageDescription,
                    numberValue: null,
                    booleanValue: null
                }
            },
            {
                key: "hasEventBanner",
                value: {
                    stringValue: null,
                    numberValue: null,
                    booleanValue: !!eventBanner
                }
            }
        ]
    });
    var ref = (0,_services_getSiteWideInitialProps__WEBPACK_IMPORTED_MODULE_4__.useClientSideCartAndUser)(), cart = ref.cart, setCart = ref.setCart, user = ref.user, reloadCustomer = ref.reloadCustomer;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isDesktop = ref1[0], setDesktop = ref1[1];
    var contentClickHandler = function(e) {
        var targetLink = e.target.closest("a");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        bind(setDesktop);
        register(setDesktop);
        return deregister(setDesktop);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isHomePage) {
            (0,_components_ScriptIntegrations_BloomreachEvents__WEBPACK_IMPORTED_MODULE_8__.bloomreachHomePagePixel)();
        } else {
            (0,_components_ScriptIntegrations_BloomreachEvents__WEBPACK_IMPORTED_MODULE_8__.bloomreachContentPageViewPixel)(pageTitle);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            return [
                Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(8764), __webpack_require__.e(8309), __webpack_require__.e(1511), __webpack_require__.e(2393)]).then(__webpack_require__.bind(__webpack_require__, 41511))
            ];
        }).then(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(param, 1), getCart = _param[0].getCart;
            return getCart();
        }).then(setCart).catch(_services_Log__WEBPACK_IMPORTED_MODULE_5__/* .error */ .vU);
    }, [
        setCart
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Default, {
        shouldUsePageView: false,
        reloadCustomer: reloadCustomer,
        user: user,
        sitewideBanner: sitewideBanner,
        megaNav: megaNav,
        meta: {
            description: pageDescription,
            title: pageTitle
        },
        cart: cart,
        onUpdateCart: setCart,
        PageContentDiv: PageContentDiv,
        eventBanner: eventBanner,
        maybeFooterFromContentful: footer,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            style: {
                marginTop: isDesktop ? "70px" : "50px"
            },
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: isDesktop ? pageHtml : pageHtml
            },
            onClick: contentClickHandler
        })
    });
};
var getPageByPageNumber = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(pageNumber) {
        var ref, ref1, Axios;
        return _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 9669, 23))
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    ref1 = ref[0];
                    Axios = ref1.default;
                    _ctx.next = 9;
                    return Axios.get("https://api.bigcommerce.com/stores/".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__.SHOP_HASH, "/v3/content/pages?limit=10s&page=").concat(pageNumber), {
                        headers: {
                            "X-Auth-Token": _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.ReadonlyBigCAccessToken
                        }
                    });
                case 9:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPageByPageNumber(pageNumber) {
        return _ref.apply(this, arguments);
    };
}();
var findPageResourceInList = function(bigcommercePagesList) {
    return function(pageResourceUrl) {
        return bigcommercePagesList.find(function(page) {
            return page.url === "/".concat(pageResourceUrl);
        }) || null;
    };
};
var getPageXmlByWithPageId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(pageId) {
        var ref, ref1, Axios, rawXml;
        return _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 9669, 23))
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    ref1 = ref[0];
                    Axios = ref1.default;
                    _ctx.next = 9;
                    return Axios.get("https://api.bigcommerce.com/stores/".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__.SHOP_HASH, "/v2/pages/").concat(pageId), {
                        headers: {
                            "X-Auth-Token": _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.ReadonlyBigCAccessToken
                        }
                    });
                case 9:
                    rawXml = _ctx.sent.data;
                    return _ctx.abrupt("return", rawXml);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPageXmlByWithPageId(pageId) {
        return _ref.apply(this, arguments);
    };
}();
var findHomePage = function(list) {
    return list.find(function(page) {
        return page.is_homepage === true;
    }) || null;
};
var findHomePageResourceInListsOfPages = function(bigcommercePagesList) {
    var ref;
    return typeof findHomePage(bigcommercePagesList) === "object" ? ((ref = findHomePage(bigcommercePagesList)) === null || ref === void 0 ? void 0 : ref.id) || null : null;
};
var getPageResourceIdFromListsOfPages = function(bigcommercePagesLists, pageResourceUrl) {
    var ref;
    return pageResourceUrl === "" ? {
        id: findHomePageResourceInListsOfPages(bigcommercePagesLists.flat()),
        isHomePage: true
    } : {
        id: ((ref = findPageResourceInList(bigcommercePagesLists.flat())(pageResourceUrl)) === null || ref === void 0 ? void 0 : ref.id) || null,
        isHomePage: false
    };
};
var getPageResource = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(pageResourceUrl) {
        var ref, list, pagination, pageData, extraPages, rawXml;
        return _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getPageByPageNumber(1);
                case 2:
                    ref = _ctx.sent;
                    list = ref.data;
                    pagination = ref.meta.pagination;
                    pageData = getPageResourceIdFromListsOfPages([
                        list
                    ], pageResourceUrl);
                    if (!(pageData.id === null)) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.next = 9;
                    return Promise.all(// Create an array of page numbers, starting at 2, and ending at the total number of pages
                    Array.from({
                        length: pagination.total_pages - 1
                    }, function(_, index) {
                        return index + 2;
                    })// Map each page number to a promise that resolves to the page data
                    .map(getPageByPageNumber));
                case 9:
                    extraPages = _ctx.sent;
                    pageData = getPageResourceIdFromListsOfPages(extraPages.map(function(param) {
                        var data = param.data;
                        return data;
                    }), pageResourceUrl);
                case 11:
                    if (!(pageData.id === null)) {
                        _ctx.next = 13;
                        break;
                    }
                    throw new Error("Page not found in catalog");
                case 13:
                    _ctx.next = 15;
                    return getPageXmlByWithPageId(pageData.id);
                case 15:
                    rawXml = _ctx.sent;
                    return _ctx.abrupt("return", {
                        rawXml: rawXml,
                        isHomePage: pageData.isHomePage
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPageResource(pageResourceUrl) {
        return _ref.apply(this, arguments);
    };
}();
var getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ctx) {
        var ref, ref1, pageResourceUrl, ref2, siteWideProps, pageObj, params, location, // Tell 302 proxy not to cache response
        // https://docs.layer0.co/guides/caching#section_caching_private_responses
        ref3, ref4, ref5, ref6, ref7, ref8;
        return _codebuild_output_src191159064_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    pageResourceUrl = (ref1 = (ref = "".concat(ctx.asPath || "").split("?")[0]) === null || ref === void 0 ? void 0 : ref.split("/")) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, item, index) {
                        return index > 0 ? "".concat(acc).concat(index > 1 ? "/" : "").concat(item) : "";
                    }, "");
                    _ctx.prev = 2;
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z;
                    _ctx.next = 6;
                    return Promise.all([
                        (0,_helpers_timePromiseAndLog__WEBPACK_IMPORTED_MODULE_9__/* .timePromiseAndLog */ .Q)("ExternalPage.getInitialProps.getSiteWideInitialProps")((0,_services_getSiteWideInitialProps__WEBPACK_IMPORTED_MODULE_4__.getSiteWideInitialProps)(ctx)),
                        (0,_helpers_timePromiseAndLog__WEBPACK_IMPORTED_MODULE_9__/* .timePromiseAndLog */ .Q)("ExternalPage.getInitialProps.getPageResource")(getPageResource(pageResourceUrl)), 
                    ]);
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref2 = (0, _ctx.t0)(_ctx.t1, 2);
                    siteWideProps = ref2[0];
                    pageObj = ref2[1];
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, siteWideProps), {
                        pageHtml: pageObj.rawXml.body,
                        pageTitle: pageObj.rawXml.meta_title,
                        pageDescription: pageObj.rawXml.meta_description,
                        isHomePage: pageObj.isHomePage
                    }));
                case 13:
                    _ctx.prev = 13;
                    _ctx.t2 = _ctx["catch"](2);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_5__/* .log */ .cM)("No page found for ".concat(pageResourceUrl));
                    (0,_services_cscLog__WEBPACK_IMPORTED_MODULE_10__/* .Log */ .Zb)({
                        level: _services_cscLog__WEBPACK_IMPORTED_MODULE_10__/* .LogLevel.ERROR */ ["in"].ERROR,
                        type: _services_cscLog__WEBPACK_IMPORTED_MODULE_10__/* .LogType.ServerRuntimeError */ .hi.ServerRuntimeError,
                        name: "Failed to initialize external page",
                        contextMap: {
                            errorString: String(_ctx.t2),
                            path: ctx.asPath || "",
                            queryParams: ctx.query
                        }
                    });
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_5__/* .error */ .vU)("Failed to load external page: ".concat(String(_ctx.t2)), _ctx.t2);
                    params = new URLSearchParams({
                        home: "".concat(String(ctx.asPath || "") || "").replace(/\//g, "")
                    });
                    location = "".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__.SHOP_ORIGIN, "/PageNotFound?").concat(String(params));
                    if ( true && window.location.href) {
                        window.location.href = location;
                    } else if (ctx.res) {
                        ;
                        (ref3 = ctx.res) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.setHeader) === null || ref4 === void 0 ? void 0 : ref4.call(ref3, "cache-control", "public, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0");
                        (ref5 = ctx.res) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.writeHead) === null || ref6 === void 0 ? void 0 : ref6.call(ref5, 302, {
                            location: location
                        });
                        (ref7 = ctx.res) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.end) === null || ref8 === void 0 ? void 0 : ref8.call(ref7);
                    }
                    return _ctx.abrupt("return", _services_getSiteWideInitialProps__WEBPACK_IMPORTED_MODULE_4__.SiteWideInitialPropsFailure);
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                13
            ]
        ]);
    }));
    return function getInitialProps(ctx) {
        return _ref.apply(this, arguments);
    };
}();
ExternalPage.getInitialProps = getInitialProps;
/* harmony default export */ __webpack_exports__["default"] = (ExternalPage);


/***/ }),

/***/ 29741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zb": function() { return /* binding */ Log; },
/* harmony export */   "hi": function() { return /* binding */ LogType; },
/* harmony export */   "in": function() { return /* binding */ LogLevel; }
/* harmony export */ });
/* unused harmony exports toContext, logger, log, debug, error, warn, fatal */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _helpers_FP__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13174);
/* provided dependency */ var process = __webpack_require__(34155);
/* eslint-disable no-console */ 




var LogType;
(function(LogType) {
    LogType["AuthorizationPrecheck"] = "AuthorizationPrecheck";
    LogType["ResponseDispatched"] = "ResponseDispatched";
    LogType["RequestingData"] = "RequestingData";
    LogType["ProcessingData"] = "ProcessingData";
    LogType["UserInputError"] = "UserInputError";
    LogType["ServerRuntimeError"] = "ServerRuntimeError";
    LogType["SuccessfulRequestFulfillment"] = "SuccessfulRequestFulfillment";
    LogType["RequestReceived"] = "RequestReceived";
})(LogType || (LogType = {}));
var LogLevel;
(function(LogLevel) {
    LogLevel["FATAL"] = "FATAL";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["WARN"] = "WARN";
    LogLevel["INFO"] = "INFO";
    LogLevel["DEBUG"] = "DEBUG";
})(LogLevel || (LogLevel = {}));
var NORMALLY_ACCEPTABLE_LEVELS = [
    LogLevel.FATAL,
    LogLevel.ERROR,
    LogLevel.WARN,
    LogLevel.INFO
];
var Log = function(logEvent) {
    if (process.env.ALLOW_DEBUG_EVENTS && "production" !== "production" && 0 || NORMALLY_ACCEPTABLE_LEVELS.includes(logEvent.level)) {
        console.log("%j", {
            logEvent: logEvent
        });
    }
};
var toContext = function(o) {
    return typeof o === "object" && o !== null ? Object.entries(o).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, key, (0,_helpers_FP__WEBPACK_IMPORTED_MODULE_0__/* .toLiteral */ .yk)(value)));
    }, {}) : {
        context: JSON.stringify(o)
    };
};
var logger = function(level) {
    return function(name) {
        return function(type) {
            return function(contextMap) {
                return Log({
                    level: level,
                    name: name,
                    type: type,
                    contextMap: toContext(contextMap)
                });
            };
        };
    };
};
var log = logger(LogLevel.INFO);
var debug = logger(LogLevel.DEBUG);
var error = logger(LogLevel.ERROR);
var warn = logger(LogLevel.WARN);
var fatal = logger(LogLevel.FATAL);


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,8924,3174,7927,9774,2888,179], function() { return __webpack_exec__(39434); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);